import { ProductSyncResult } from "./Product";
import {
  MultilingualNotificationMessage,
  NotificationMessage
} from "./Notification";

export interface SelectableValues {
  notificationTypes: ReadonlyArray<string>;
  targetGroupTypes: ReadonlyArray<string>;
}

export interface EmailSender {
  email: string;
  name: string;
  replyTo?: EmailSender;
}

export interface EmailTemplate {
  id: string;
  description: string;
  notificationType: string;
  sender: EmailSender;
  dynamicData: {
    unsubscribeId: number;
  };
  created: Date;
  updated: Date;
  texts: EmailTemplateTexts;
}

export interface EmailTemplateTexts {
  swedish: EmailTemplateText;
  english: EmailTemplateText;
}

export interface EmailTemplateText {
  sendGridTemplateId: string;
  subject: string;
  body: string;
  default: boolean;
}

export interface CreateEmailTemplate {
  description: string;
  notificationType: string;
  unsubscribeId: string;
  senderName: string;
  senderEmail: string;
  swedishSendGridTemplateId: string;
  englishSendGridTemplateId?: string;
}

export interface SendEmailPreview {
  userEmail: string;
  emailTemplateId: string;
}

export interface SendEmailToTargetGroup {
  targetGroup: string;
  emailTemplateId: string;
  emailTemplate: EmailTemplate;
  storeIds: ReadonlyArray<string>;
  campaignId?: string;
  segmentId?: string;
}

export interface SendPushNotificationToTargetGroup {
  targetGroup: string;
  storeIds: ReadonlyArray<string>;
  messages: { [key: string]: NotificationMessage };
  campaignId?: string;
  segmentId?: string;
}

export const emptyEmailTemplate = (): EmailTemplate => ({
  id: "",
  description: "",
  created: new Date(),
  dynamicData: {
    unsubscribeId: 0
  },
  notificationType: "",
  sender: {
    email: "",
    name: ""
  },
  updated: new Date(),
  texts: {
    english: {
      subject: "",
      body: "",
      sendGridTemplateId: "",
      default: true
    },
    swedish: {
      subject: "",
      body: "",
      sendGridTemplateId: "",
      default: false
    }
  }
});

export const targetGroupToDisplayName = (targetGroup: string): string => {
  let result = "";
  for (let i = 0; i < targetGroup.length; i++) {
    let character = targetGroup.charAt(i);
    if (i > 0 && character == character.toUpperCase()) {
      result += " " + character;
    } else {
      result += character;
    }
  }
  return result;
};
